import React from "react";
import { Card, CardImg, CardText, CardBody, CardTitle, CardFooter, CardLink, Row, Col } from "reactstrap";
import { useSwiper } from "swiper/react/swiper-react";

import styles from "./Carousel.module.scss";
import arrowIcon from "../../assets/arrow-right.svg";

interface CarouselProps {
  variant?: "homepage" | "what-we-do";
  slideIndex: number;
  data: {
    post_title: "";
    link: "";
    content: "";
    image: "";
    format: {
      name: "";
    };
    location: {
      name: "";
    };
  };
}

export default function CarouselCard({ variant = "homepage", data, slideIndex }: CarouselProps) {
  const swiper = useSwiper();
  if (!data) return null;

  return (
    <Card
      className={`${styles.card} text-dark`}
      tag="a"
      href={data.link}
      onClick={(e) => {
        if (swiper?.swiper !== null && swiper.swiper.activeIndex !== slideIndex) {
          console.log("Swiper Value", swiper);
          e.preventDefault();
          swiper.swiper.slideTo(slideIndex);
        }
      }}
    >
      <CardImg
        className={styles.cardImage}
        src={data.image}
        style={{ height: variant === "homepage" ? "100%" : "50%" }}
      />
      <CardBody className={styles.cardBody} style={{ width: variant === "homepage" ? "50%" : "100%" }}>
        <div>
          <CardTitle className={styles.cardTitle}>{data.post_title}</CardTitle>
          <CardText className={styles.cardDescription} dangerouslySetInnerHTML={{__html: data.content}} />
        </div>
        <Row>
          <Col xs="9" md="8">
            <CardLink className={styles.cardSubText}>{data.format && data.format.name}</CardLink>
            <CardLink className={styles.cardSubText}>{data.location}</CardLink>
          </Col>
          <Col xs="3" md="4" className="text-right">
            <CardLink>
              <img src={arrowIcon} alt="arrow icon" />
            </CardLink>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}
